import moment from 'moment';
import React from 'react';

const TIME_INPUT_FORMATS = [moment.ISO_8601, 'HH:mm:ss', 'HH:mm', 'h:mm A', 'hh:mm A'];

export interface IProps {
  fallback: React.ReactNode;
  format: string;
  skipUtc: boolean;
  value?: moment.MomentInput;
}

class TimeLabel extends React.Component<IProps> {
  static defaultProps: Partial<IProps> = {
    fallback: '',
    skipUtc: false,
    format: 'HH:mm'
  };

  private parseValue(value: moment.MomentInput, skipUtc: boolean) {
    if (typeof value === 'string') {
      return skipUtc
        ? moment(value, TIME_INPUT_FORMATS, true)
        : moment.utc(value, TIME_INPUT_FORMATS, true);
    }

    return skipUtc ? moment(value) : moment.utc(value);
  }

  render() {
    const { value, skipUtc, format, fallback } = this.props;

    if (!value) return <span>{fallback}</span>;

    const parsedMoment = this.parseValue(value, skipUtc);

    if (!parsedMoment.isValid()) return <span>{fallback}</span>;

    return <span>{parsedMoment.format(format)}</span>;
  }
}
export default TimeLabel;
